import { Inject, Injectable } from '@angular/core';

import { L10nBase } from '@skylab-shared/core';

import { L10n } from '@skylab-angular-shared/core';
import { ServiceGridColumn } from '@skylab-angular-shared/ui';
import { FiscalDevicePaymentMethodsParametersMappingModelWrapper } from '../../fiscal-device-dialog-grid-item';

export type FiscalDeviceDialogPaymentMethodGridColumnIdentitiy = 'model' | 'paymentMethodId';
export type FiscalDeviceDialogPaymentMethodGridCustomTemplates = 'fiscalDeviceDialogGridPaymentMethodId';

@Injectable({
    providedIn: 'root'
})
export class FiscalDeviceDialogPaymentMethodGridService {

    public constructor(
        @Inject(L10n) private readonly l10n: L10nBase
    ) {}

    public getGridColumns(): ServiceGridColumn<FiscalDeviceDialogPaymentMethodGridColumnIdentitiy, unknown, FiscalDevicePaymentMethodsParametersMappingModelWrapper, unknown, FiscalDeviceDialogPaymentMethodGridCustomTemplates>[] {
        return [
            {
                header: this.l10n._T('scenes.configuration.shared.fiscalization.dialog.grid.columns.device-payment-method.title'),
                identityName: 'model',
                columnDef: 'model',
                width: '150px',
                cell: entity => entity.model.mapped,
                isResizable: false,
                isMovable: false,
                fillingColumn: true,
            },
            {
                header: this.l10n._T('scenes.configuration.shared.fiscalization.dialog.grid.columns.system-payment-method.title'),
                identityName: 'paymentMethodId',
                columnDef: 'paymentMethodId',
                width: '150px',
                template: 'fiscalDeviceDialogGridPaymentMethodId',
                isResizable: false,
                isMovable: false,
            },
        ];
    }
}
